import { emit } from "../../utilities/events.js";
import { systemIcons } from "./iconset.system.js";
const svgToDataURI = (svg) => svg ? `data:image/svg+xml;utf8,${encodeURIComponent(svg)}` : "";
const defaultMutator = (svg) => svg.setAttribute("fill", "currentColor");
class LeafIconSet {
  /**
   * Create a new icon set.
   *
   * @param {String} name the name for the set of icons, used by icon
   * @param {Function} resolver the function that will resolve an icon to a URI
   * @param {Function} mutator the function that will mutate the svg before render
   */
  constructor(name, resolver, mutator) {
    this.name = name;
    this.resolver = resolver;
    this.mutator = mutator;
  }
  /**
   * Get an individual icon from the set, returns URI for the icon
   */
  getIconURI(name) {
    return this.resolver(name, this.name);
  }
  /**
   * Mutate or alter an svg with mutator function if it exists
   * @param svg svg to mutate
   * @param name name of the icon being mutated
   */
  mutate(svg, name) {
    if (this.mutator) {
      this.mutator(svg, name);
    }
  }
}
class LeafIconLibrary {
  constructor() {
    this.iconSets = /* @__PURE__ */ new Map();
    this.emit = (name, detail) => emit(name, { detail });
  }
  static getInstance() {
    if (!LeafIconLibrary.instance) {
      LeafIconLibrary.instance = new LeafIconLibrary();
    }
    return LeafIconLibrary.instance;
  }
  add(name, resolver, mutator) {
    const iconset = new LeafIconSet(name, resolver, mutator);
    this.iconSets.set(iconset.name, iconset);
    this.emit("leaf:iconset-added", { name: iconset.name, iconset });
    return iconset;
  }
  remove(name) {
    this.iconSets.delete(name);
    this.emit("leaf:iconset-removed", { name });
  }
  getIconSet(name) {
    return this.iconSets.get(name);
  }
}
LeafIconLibrary.getInstance().add("system", (name) => svgToDataURI(systemIcons[name]));
export {
  LeafIconLibrary,
  LeafIconSet,
  defaultMutator,
  svgToDataURI
};
//# sourceMappingURL=library.js.map
